import React from 'react';
import { Check } from 'lucide-react';
import { StarRating } from './StarRating';
import { PrimaryCTA } from './PrimaryCTA';
export function BuyBox() {
  return <div className="my-16 bg-white border-2 border-gray-200 rounded-xl p-8 shadow-lg" data-id="element-12">
      <div className="max-w-md mx-auto" data-id="element-13">
        {/* Product image */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-8 mb-6" data-id="element-14">
          <img src="https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=800&q=80" alt="Chime Breathing Necklace" className="w-full h-auto rounded-lg shadow-md" data-id="element-15" />
        </div>

        {/* Product info */}
        <div className="text-center mb-6" data-id="element-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-17">
            Chime Breathing Necklace
          </h3>
          <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-18">
            <span className="text-3xl font-bold text-gray-900" data-id="element-19">$40</span>
            <span className="text-sm text-gray-500" data-id="element-20">One-time purchase</span>
          </div>
          <StarRating size="lg" className="justify-center" data-id="element-21" />
        </div>

        {/* What's included */}
        <div className="bg-gray-50 rounded-lg p-6 mb-6" data-id="element-22">
          <p className="font-semibold text-gray-900 mb-3" data-id="element-23">What's Included:</p>
          <ul className="space-y-2" data-id="element-24">
            {['Calibrated breathing pendant', 'Free guided breathwork course', '30-day money-back guarantee', 'HSA/FSA eligible'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-25">
                <Check size={16} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-26" />
                <span data-id="element-27">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* CTA */}
        <PrimaryCTA className="w-full" data-id="element-28" />

        <p className="text-xs text-center text-gray-500 mt-4" data-id="element-29">
          Free shipping · Secure checkout · 50,000+ customers
        </p>
      </div>
    </div>;
}